import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  getTransferToFacilities,
  approveTransferToFacilities,
  rejectTransferToFacilities,
} from "store/transfer-to-facility/transfer-to-facility-action"
import TransferToFacilityListComponent from "components/TransferToFacility/list"

const TransferToFacilityList = () => {
  document.title = "Transfer to Facility"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.transferToFacility)
  const [pageNumber, setPageNumber] = useState(10)
  const [selectedIds, setSelectedIds] = useState([])

  // Fetch transfers when component mounts
  useEffect(() => {
    dispatch(getTransferToFacilities(pageNumber))
  }, [pageNumber])

  // Handle page click for pagination
  const onPageClick = link => {
    dispatch(getTransferToFacilities(pageNumber))
  }

  // Handle row number change
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Handle checkbox selection
  const handleCheckboxChange = (id, checked) => {
    if (checked) {
      setSelectedIds([...selectedIds, id])
    } else {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== id))
    }
  }

  // Handle select all checkbox
  const handleSelectAll = checked => {
    if (checked) {
      const pendingIds = data?.data
        ?.filter(item => item.status === "Pending")
        .map(item => item.id) || []
      setSelectedIds(pendingIds)
    } else {
      setSelectedIds([])
    }
  }

  // Handle approve action
  const handleApprove = () => {
    if (selectedIds.length === 0) {
      return
    }
    dispatch(
      approveTransferToFacilities(selectedIds, success => {
        if (success) {
          setSelectedIds([])
        }
      })
    )
  }

  // Handle reject action
  const handleReject = () => {
    if (selectedIds.length === 0) {
      return
    }
    dispatch(
      rejectTransferToFacilities(selectedIds, success => {
        if (success) {
          setSelectedIds([])
        }
      })
    )
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Transfer to Facility"} />
 
      <TransferToFacilityListComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onChangeRowNumber={onChangeRowNumber}
        selectedIds={selectedIds}
        onCheckboxChange={handleCheckboxChange}
        onSelectAll={handleSelectAll}
        onApprove={handleApprove}
        onReject={handleReject}
      />
    </React.Fragment>
  )
}

export default TransferToFacilityList
